import { render, staticRenderFns } from "./CovByProp.vue?vue&type=template&id=e86837ee&"
import script from "./CovByProp.vue?vue&type=script&lang=js&"
export * from "./CovByProp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports